/** Public workspace transport. A token is a read capability for ONE saved page. */
export const PUBLIC_PAGE_TOKEN = /^[a-f0-9]{32}$/;
export function publicPageToken(pathname: string): string | null {
  return /^\/shared\/page\/([a-f0-9]{32})\/?$/.exec(pathname)?.[1] ?? null;
}
export function currentPublicPageToken(): string | null {
  return typeof window === "undefined" || !window.location ? null : publicPageToken(window.location.pathname);
}
export function publicPageDataUrl(token: string, path: string): string {
  return `/api/shared/page/${token}/data?path=${encodeURIComponent(path)}`;
}
export const PUBLIC_PAGE_READ_POSTS = new Set(["/api/photos", "/api/stock-history", "/api/supply-planning"]);
export function publicReadMethod(path: string, method: string): boolean {
  return method === "GET" || method === "HEAD" || method === "POST" && PUBLIC_PAGE_READ_POSTS.has(path);
}
